import PedidoPagamentoService from "@/services/PedidoPagamentoService";

export const pedidoPagamento = {
  namespaced: true,
  state: {
    pedidoPagamento: {},
  },
  actions: {
    getPedidoPagamento({ commit }, payload) {
      return PedidoPagamentoService.GetPedidoPagamento(payload).then(
        (pedidoPagamento) => {
          return Promise.resolve(pedidoPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postPedidoPagamento({ commit }, payload) {
      return PedidoPagamentoService.PostPedidoPagamento(payload).then(
        (pedidoPagamento) => {
          return Promise.resolve(pedidoPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putPedidoPagamento({ commit }, payload) {
      return PedidoPagamentoService.PutPedidoPagamento(payload).then(
        (pedidoPagamento) => {
          return Promise.resolve(pedidoPagamento);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deletePedidoPagamento({ commit }, payload) {
      return PedidoPagamentoService.DeletePedidoPagamento(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getPedidoPagamentoOData({ commit }, payload) {
      return PedidoPagamentoService.GetPedidoPagamentoOData(payload).then(
        (pedidoPagamento) => {
          return Promise.resolve(pedidoPagamento);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default pedidoPagamento;
